module.exports = ".range-date-picker {\n  width: 264px; }\n\n.calendar {\n  width: 30px;\n  height: 30px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/range-date-picker/range-date-picker.component.scss
// module id = ./src/app/shared/components/range-date-picker/range-date-picker.component.scss
// module chunks = main